<template>
    <div>
        <div class="add-rule__form" v-if="popups.addRule.show">
            <div class="add-rule__form--ghost" v-if="showGhost">
                <div class=""></div>
                <div class=""></div>
            </div>
            <div v-else>
				<div :class="{'df df--space-between': user.access_rights.is_tech_writer || user.access_rights.is_owner}" >
					<div :class="{'tech-writer-inpt': user.access_rights.is_tech_writer || user.access_rights.is_owner}">
						<input-styled
		                    v-if="item.id"
		                    name="title"
		                    :placeholder="'Заголовок'"
		                    :placeholderInput="'Заголовок'"
		                    @input="changeTitle"
		                    v-model="form.title.value"
							:maxLengthNum="85"
		                    @focus="form.title.error=false"
		                    :is-error="form.title.error">
		                </input-styled>
		                <input-styled
		                    v-else
		                    name="title"
		                    :auto-focus="true"
		                    @input="changeTitle"
		                    :placeholder="'Заголовок'"
		                    :placeholderInput="'Заголовок'"
		                    v-model="form.title.value"
							:maxLengthNum="85"
		                    @focus="form.title.error=false"
		                    :is-error="form.title.error">
		                </input-styled>
					</div>
					<div class="filter" v-if="user.access_rights.is_owner || user.access_rights.is_tech_writer">
						<input-select-new @change="changeType" :tag="'div'" v-model="form.filterType.value" :options="typesOptions" :placeholder="'Тип'" :list-style="{'max-height': 'none'}"></input-select-new>
					</div>
				</div>
                <div class="textarea-field mt16"
                     :class="{'error': form.text.error, 'repeat-error': repeatTextareaError}">
                    <div class="editor">

                        <span class="i i-info3"></span>
                        <editor-content @showimage="showImage" class="inp" :editor="editor"/>
                    </div>
                    <div class="bottom-text">
                        не менее 10-ти символов
                    </div>
                </div>
            </div>
            <rule-history v-if="item" :item="item" />
        </div>
        <div class="viewer-container viewer-backdrop viewer-fixed viewer-hooper viewer-fade" ref="viewerAddRule"
             @keyup.space="slideNext" @keyup.esc="closeViewer">

            <div class="viewer-canvas-wrapper">

                <div class="viewer-canvas" :class="{'nav-hovered-prev': hoveredPrev, 'nav-hovered-next': hoveredNext}">
                    <hooper @slide="slide" class="carousel-thumbs viewer-carousel" ref="viewerHooperAddRule"
                            :infiniteScroll="files.length < 2 ? false : true">

                        <slide :key="index"
                               v-for="(item,index) in files">
                            <div class="item" v-if="item.mediaType == 'photo'">
                                <img v-lazy="item.host+item.path" alt="" class="js-img"
                                     v-if="item.host && files != [] && (currentSlide == index+1 || currentSlidePrev == index) && isShowedViewer">
                                <img v-lazy="item.path" alt=""
                                     v-else-if="files != [] && (currentSlide == index+1 || currentSlidePrev == index) && isShowedViewer">
                                <div class="inner-nav" v-if="files.length > 1">
                                    <div class="prev" @click="slidePrev" @mouseover="hoveredPrev = true"
                                         @mouseleave="hoveredPrev = false"></div>
                                    <div class="next" @click="slideNext" @mouseover="hoveredNext = true"
                                         @mouseleave="hoveredNext = false"></div>
                                </div>
                            </div>
                            <div class="item" v-else-if="item.mediaType == 'yt-video'">
                                <iframe width="1100"
                                        height="450"
                                        v-if="files != [] && (currentSlide == index+1 || currentSlidePrev == index) && isShowedViewer"
                                        :src="'https://www.youtube.com/embed/'+item.id+'?enablejsapi=1'"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <div class="inner-nav" v-if="files.length > 1">
                                    <div class="prev" @click="slidePrev" @mouseover="hoveredPrev = true"
                                         @mouseleave="hoveredPrev = false"></div>
                                    <div class="next" @click="slideNext" @mouseover="hoveredNext = true"
                                         @mouseleave="hoveredNext = false"></div>
                                </div>
                            </div>
                            <div class="item" v-else-if="item.mediaType == 'vk-video'">
                                <iframe
                                v-if="files != [] && (currentSlide == index+1 || currentSlidePrev == index) && isShowedViewer"
                                    :src="item.id"
                                    width="853" height="480"
                                    allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
                                    frameborder="0" allowfullscreen>
                                </iframe>
                                <div class="inner-nav" v-if="files.length > 1">
                                    <div class="prev" @click="slidePrev" @mouseover="hoveredPrev = true"
                                         @mouseleave="hoveredPrev = false"></div>
                                    <div class="next" @click="slideNext" @mouseover="hoveredNext = true"
                                         @mouseleave="hoveredNext = false"></div>
                                </div>
                            </div>
                        </slide>
                        <hooper-navigation slot="hooper-addons" v-if="files.length > 1"></hooper-navigation>
                    </hooper>
                </div>
                <div role="button" class="viewer-button viewer-close" @click="closeViewer"></div>
                <div class="photo-num">
                    {{ currentSlide }}
                </div>
            </div>
        </div>
        <popup :is-set-styled="false" :show="popups.recoverRule.show" :name="popups.recoverRule.name" :width="512">
            <div class="popup-info popup-icon-info">
                <svg style="height: 48px;">
                    <use xlink:href="@/assets/img/big-icons-sprite.svg#recover"></use>
                </svg>

                <div class="text mt24">
                    <div class="text-size-l text-bold info-title">Восстановить правило?</div>

                    <p class="info-text mt16">
                        Оно вернётся в категорию, из которой было удалено.
                    </p>
                </div>

                <div class="mt24">
                    <submit-btn @click.native="send(true)" :type="form.btnType"><span v-if="form.btnType=='normal'"
                                                                                  class="i i-ok7 mr8"></span>Подтвердить
                    </submit-btn>
                </div>
            </div>
        </popup>
        <popup :is-set-styled="false" :show="popups.notify.show" :name="popups.notify.name" :width="834"
               @close="closeNotifyForm">
            <div>
                <div class="text-size-l text-bold text-color mb24">Письмо пользователям</div>
                <div class="full">
                    <input-styled
                        name="notifyTitle"
                        :auto-focus="true"
                        :placeholder="'Тема'"
                        :placeholderInput="'Тема'"
                        v-model="form.notifyTitle.value"
                        @focus="form.notifyTitle.error=false"
                        :is-error="form.notifyTitle.error"></input-styled>
                    <textarea-field :class="'full mt16'"
                                    v-model="form.notifyText.value"
                                    :error-text="''"
                                    :is-error="form.notifyText.error"
                                    @focus="form.notifyText.error=false"
                                    placeholder="Текст"
                                    :add-style="{height: 220 + 'px'}"></textarea-field>
                </div>
                <div class="row-b mt24">
                    <div class="row-b__col elem-pos-fix mr24">
                        <submit-btn class="btn--ico" ref="notifySendBtn" @click.native="send(true)"
                                    :type="form.sendMsg.btnType">
                            <span v-if="form.sendMsg.btnType=='normal'" style="margin-top: -1px"
                                  class="i i-send mr4"></span>Отправить уведомления
                        </submit-btn>
                        <div v-if="isLoadNotifyData" class="recipients text-size-s text-color-grey ml24">

                        </div>
                        <div v-else class="recipients text-size-s text-color-grey ml24">
                            Получатели: {{ notifyData.subscribersCount }} чел.
                        </div>
                    </div>
                    <div class="">

                    </div>
                    <div class="tumbler__email-notify">
                        <tumbler
                            :name="tumblers.notifySms.name"
                            :value="tumblers.notifySms.value"
                            :icon="'i i-notify'"
                        >
                        </tumbler>
                        Отправить всем СМС «Проверьте почту»
                    </div>

                </div>
            </div>
        </popup>
        <popup :is-set-styled="false" :show="popups.moveRule.show" :name="popups.moveRule.name" :width="464" >
            <move-rule :sections="moveSections" @move="send(false)"></move-rule>
        </popup>
    </div>
</template>

<script>


import {mapState} from 'vuex'
import InputStyled from '@/components/forms/InputStyled.vue';
import Popup from '@/components/modal/Popup.vue';
import TextareaField from '@/components/forms/TextareaField.vue';
import InputSelect from '@/components/forms/InputSelect.vue';
import Tooltip from '@/components/Tooltip.vue';
import SubmitBtn from '@/components/forms/SubmitBtn.vue'
import TextEditorNew from '@/components/editor/TextEditorNew.vue'
import draggable from '@/helpers/vuedraggable.js';
import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper'; // carousel
import Tumbler from '@/components/Tumbler.vue';
import {EditorContent, EditorMenuBar} from 'tiptap';
import InputSelectNew from '@/components/forms/InputSelectNew.vue';
import MoveRule from '@/components/modal/rules/MoveRule.vue';
import RuleHistory from '@/components/moderator/Rules/RuleHistory.vue';
import { findSectionById } from '../../../helpers/util/helper';

export default {
    name: "AddRule",
    components: {
        InputStyled,
        TextareaField,
        InputSelect,
        SubmitBtn,
        draggable,
        Hooper,
        Slide,
        HooperNavigation,
        TextEditorNew,
        EditorContent,
        Tooltip,
        EditorMenuBar,
        Popup,
        InputSelectNew,
        Tumbler,
        MoveRule,
        RuleHistory
    },
    props: {
        regionsProp: {},
        show: {
            default: function () {
                return false
            }
        },
        name: '',
        editor: {},
        focused: {
            default: function () {
                return false
            }
        },
        inputText: '',

    },
    data: function () {
        return {
            regions: {},
            countSelect: 0,
            init: false,
            openAside: false,
            button: 'normal',
            loadFiles: false,
            currentSlide: 1,
            currentSlidePrev: 1,
            isShowedViewer: false,
            secondSections: [],
            hoveredPrev: false,
            hoveredNext: false,
            isSave: false,
            showGhost: true,
			techWriter: 1,
            newCreatedId: null,
			typesOptions: [
				{id: 1, name: 'заготовка'},
				{id: 2, name: 'черновик'},
				{id: 4, name: 'правило'},
                {id: 5, name: 'архивное'},
			],
			techOptions: [
				{id: 1, name: 'Анна Ахматов'},
				{id: 2, name: 'Константин Константинопольский'},
				{id: 3, name: 'Евгений Иванов'},
				{id: 4, name: 'Павел МОрозов'},
				{id: 5, name: 'Илья Сниченко'},
			],
            moveSections: {
                from: {
                    top: '',
                    sub: '',
                },
                to: {
                    top: '',
                    sub: '',
                },
            },
            form: {
				filterType: {
					value: 1,
				},
                itemId: {
                    value: "",
                },
                notifyTitle: {
                    value: "",
                    error: false,
                },
                notifyText: {
                    value: "",
                    error: false,
                },
                notifySms: {
                    value: false,
                    error: false,
                },
                text: {
                    value: "",
                    error: false,
                },
                section: {
                    value: "",
                    error: false,
                },
                category: {
                    value: "",
                    error: false,
                },
                title: {
                    value: '',
                    error: false,
                },
                topSection: {
                    value: '',
                    error: false,
                },
                sendMsg: {
                    btnType: 'normal',
                },
                screen: [],
                screenError: [false, false, false],
                btnType: 'normal',
                fileInput: [],
                tmpFiles: [],
                tmpFilesAppend: [],
                removeFiles: [],
                filesDragRun: false,
            },
            isNotifyNew: false,
            fieldName: 'file',
            appPath: process.env.VUE_APP_PATH_BACK,
            repeatTextareaError: false,
        }
    },
    created() {
        window.addEventListener('beforeunload', this.handlerBeforeUnload)
    },
    mounted: function () {
        document.addEventListener('showimage', this.showImage);
        document.addEventListener('showvideo', this.showImage);
        document.addEventListener('keyup', this.keyUp);
        this.$store.dispatch('rules/setTimerBlockEdit', {id: this.item.id});
        if (this.isEdit) {
            this.setItem();
        } else {
            this.showGhost = false;
        }

        if (this.editor) {
        this.editor.on('update', () => {
            this.form.text.value = this.editor.getHTML()
        });
  }

    },
    beforeDestroy() {
        if (!(this.blockEdit && this.blockEdit.status)) {
            this.$store.dispatch('rules/clearBlockEdit', {id: this.item.id});
        }
        if (this.item.id || this.isSave) {
            this.$emit('scroll', this.item.id ? this.item.id : 'new', this.newCreatedId);
        }
        document.removeEventListener('showimage', this.showImage);
        document.removeEventListener('showvideo', this.showImage);
        document.removeEventListener('keyup', this.keyUp);
        window.removeEventListener('beforeunload', this.handlerBeforeUnload);
        this.$store.commit('rules/tumblerOff', this.tumblers.notify.name);
        this.$emit('close');
    },
    watch: {
        focused() {
            this.form.text.error = false;
        },
        inputText() {
            this.form.text.value = this.inputText;

        },
        show: function () {
        },
        'form.text.error'(val, oldVal) {
            if (oldVal) {
                this.repeatTextareaError = true;
            }
        },
        'editor.focused'(val) {
            if (val) {
                this.repeatTextareaError = false;
            }
        }
    },
    computed: {
        ...mapState({
            popups: state => state.popups.items,
            item: state => state.rules.editItem,
            sections: state => state.rules.sections,
            selectSections: state => state.rules.selectSections,
            tempSections: state => state.rules.tempSections,
            topSections: state => state.rules.topSections,
            tumblers: state => state.rules.tumblers,
            notifyData: state => state.rules.notifyData,
            isLoadNotifyData: state => state.rules.isLoadNotifyData,
            rule: state => state.rules.openedRule,
            isEdit: state => state.rules.isEdit,
            sectionsLock: state => state.rules.sectionsLock,
            user: state => state.users.user,
        }),
        activeTopSection() {
            if (this.isSearch) return false;
            return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
        },
        activeSection() {
            let subSectionID;
            if(this.$route.params.subid){
                subSectionID = this.$route.params.subid
            }
            else if(this.sections){
                subSectionID = this.sections[0].id;
            }
            return subSectionID;
        },
        files: {
            get() {
                let files = this.$store.getters['rules/getItemFiles'];
                return files ? files : [];
            },
            set(value) {
                this.$store.commit('rules/setItemFiles', {
                    items: value
                });
            }
        },
        isRemovedPage() {
            return this.$route.name == 'rules-removed';
        }
    },

    methods: {
        changeTitle() {
            this.$emit('change');
        },

        changeType() {
            this.$emit('change');
        },

        closeNotifyForm() {
            this.$store.commit('rules/tumblerOff', 'notify');
            this.$store.commit('rules/tumblerOff', 'notifySms');
            this.$store.commit('popups/close', {name: this.popups.notify.name});
            this.$store.commit('popups/close', {name: this.popups.addRule.name});
            this.$store.commit('popups/close', {name: this.popups.recoverRule.name});
            if (document.querySelector('.rules')) {
                document.querySelector('.rules').style.opacity = ''
            }
            ;
        },
        setItem() {
            let data = {...this.item};
            data.text = '';
            this.$store.dispatch('rules/getRuleText', {item: data, removed: this.isRemovedPage}).then((item) => {
                this.$store.dispatch('rules/setEditItem', item).then(() => {
                    if (item.name) {
                        this.form.title.value = item.name.replace(/(&nbsp;)/g, ' ');
                    }


                    this.form.filterType.value = item.ruleType ? item.ruleType : 1;

                    if (item.section) {
                        this.form.section.value = this.getSectionName(item.section);
                    } else {
                        this.form.section.value = this.getSectionName(this.activeSection);
                    }

                    this.secondSections = this.sections;
                    this.form.topSection.value = this.activeTopSection;
                    this.form.category.value = this.activeSection;


                    this.$store.commit('rules/setItemFiles', {items: []});


                    if (item.text) {
                        this.form.text.value = item.text.replace(/(&nbsp;)/g, ' ');
                    }

                    setTimeout(() => {
                        if (this.form.text.value) {
                            if (this.form.text.value.indexOf('<p') === -1) {
                                this.editor.setContent('<p>' + this.form.text.value.replace(/(&nbsp;)/g, ' ').replace(/(?:\r\n|\r|\n)/g, '<br />') + '<p>')
                            } else {
                                this.editor.setContent(this.form.text.value.replace(/(&nbsp;)/g, ' ').replace(/(?:\r\n|\r|\n)/g, '<br />'))
                            }
                            this.editor.focus('start');
                            this.updateImages(this.form.text.value);
                            setTimeout(() => {
                                this.$store.commit('rules/setLoadEditRule', false);
                            }, 50);
                        }
                        this.showGhost = false;
                        this.$store.commit('rules/setLoadItems', false);
                    }, 50);
                });
            });
        },
        handlerBeforeUnload(e) {
            e.returnValue = null;
            return null;
        },
        updateImages(text) {
            if (text) {
                let result = text.match(/<span[\s\S]*?class="(image|youtube)"[\s\S]*?\/span>/gi);
                let IDs = [];
                let files = [];
                for (let r in result) {
                    let div = document.createElement('div');
                    div.innerHTML = result[r];
                    let type;
                    let element;
                    if (div.querySelector("span.image")) {
                        element = div.querySelector("span.image");
                        type = 'image';
                    }
                    if (div.querySelector("span.youtube")) {
                        element = div.querySelector("span.youtube");
                        type = element.getAttribute("data-type");
                    }
                    IDs.push(element.dataset.id);
                    if (type === 'image') {
                        IDs.push(element.dataset.id);
                        let host = element.dataset.href.indexOf('https://zems.pro') > -1 ? 'https://zems.pro' : element.dataset.href.indexOf('https://rules.su') > -1 ? 'https://rules.su' : false;
                        let href = element.dataset.href.replace('https://zems.pro', '').replace('https://rules.su', '');
                        this.$store.commit('rules/addFile', {
                            id: element.dataset.id,
                            path: href,
                            icon: href,
                            mediaType: 'photo',
                            host: host
                        });

                    }
                    if (type === 'youtube') {
                        let id = element.dataset.id;
                        let path = '//img.youtube.com/vi/' + id + '/mqdefault.jpg'
                        this.$store.commit('rules/addFile', {id: id, path: path, icon: path, mediaType: 'yt-video'});
                    }
                    if (type === 'vk') {
                        let id = element.dataset.id;
                        let path = '//img.youtube.com/vi/' + id + '/mqdefault.jpg'
                        this.$store.commit('rules/addFile', {id: id, path: path, icon: path, mediaType: 'vk-video'});
                    }

                }
                return files;
            }
        },

        getSubsections(event) {
            this.$store.dispatch('rules/getSubsectionOption', {id: event}).then((result) => {
                this.secondSections = result;
                if (result.length > 0) {
                    this.form.category.value = result[0].id;
                }
            });
        },

        close: function () {
            if (this.show && this.name) {
                this.$store.commit('popups/close', {name: this.name});
                document.getElementsByTagName('body')[0].classList.remove("noscroll")
            }
        },
        slide(payload) {
            this.currentSlide = +payload.currentSlide == -1 ? this.files.length : +payload.currentSlide + 1;
            if (this.files && +this.currentSlide > this.files.length) {
                this.currentSlide = 1;
            }
            this.currentSlidePrev = +payload.slideFrom
            this.pauseVideos();
        },
        inputFocus(ref) {
            if (!!this.$refs[ref]) {
                this.$nextTick(() => {
                    this.$refs[ref].focus()
                });
            }
        },
        slideNext() {
            this.$refs.viewerHooperAddRule.slideNext();
        },
        slidePrev() {
            this.$refs.viewerHooperAddRule.slidePrev();
        },
        pauseVideos() {
            [...document.getElementsByTagName('iframe')].forEach(i => i.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'));
        },
        closeViewer() {
            this.pauseVideos();
            if (this.isShowedViewer) {
                this.$refs.viewerAddRule.classList.add('viewer-transition');
                this.$refs.viewerAddRule.classList.remove('viewer-in');
                document.getElementsByTagName('body')[0].classList.remove("popup-noscroll");
                let self = this;
                setTimeout(function () {
                    if (self.$refs.viewerAddRule) {
                        self.$refs.viewerAddRule.classList.remove('viewer-transition');
                    }
                    if (self.$refs.viewerHooperAddRule) {
                        self.$refs.viewerHooperAddRule.restart();
                    }
                    self.isShowedViewer = false;
                }, 200);
            }
        },
        showViewer(index) {
            this.$refs.viewerAddRule.classList.add('opening');
            this.$refs.viewerHooperAddRule.slideTo(index);
            this.$refs.viewerAddRule.classList.add('viewer-transition');
            this.$refs.viewerAddRule.querySelector('.hooper-track').setAttribute('tabindex', 0);
            let self = this;
            setTimeout(function () {
                self.$refs.viewerAddRule.classList.remove('viewer-transition');
                self.$refs.viewerAddRule.classList.remove('opening');
            }, 400);
            setTimeout(function () {
                self.$refs.viewerAddRule.classList.add('viewer-in');
                document.getElementsByTagName('body')[0].classList.add("popup-noscroll");
                self.isShowedViewer = true;
                self.$refs.viewerAddRule.querySelector('.hooper-track').focus();
            }, 10);
        },
        removeHtmlTags(str) {
            return str.replace(/<[^>]*>/g, '');
        },
        validateForm: function () {
            let error = false;
            this.repeatTextareaError = false;
            let trimmedText = this.removeHtmlTags(this.form.text.value).trim();
            if (!this.form.text.value || trimmedText.length < 10) {
                if (this.form.text.error) {
                    this.form.text.error = false;
                    setTimeout(() => {
                        this.form.text.error = true;
                    }, 10);
                } else {
                    this.form.text.error = true;
                }
                error = true;
            }
            if (!this.form.title.value || this.form.title.value.length == 0) {
                if (this.form.title.error) {
                    this.form.title.error = false;
                    setTimeout(() => {
                        this.form.title.error = true;
                    }, 10);
                } else {
                    this.form.title.error = true;
                }
                error = true;
            }

            return !error;
        },
        async send(checkMove) {
            let error = !this.validateForm();
            await this.$store.dispatch('rules/getTempSections', { id: this.item.sectionTop});
            if(checkMove && this.item.id && this.activeSection !== this.item.section){
                const toSection = findSectionById(this.sections, this.activeSection);
                let fromSections = this.activeSection === this.item.section ? this.sections : this.tempSections;
                const fromSection = findSectionById(fromSections, this.item.section);
                this.moveSections = {
                    from: {
                        top: this.item.sectionTopName,
                        sect: fromSection.parentSection ? fromSection.parentSection.name : fromSection.section.name,
                        sub: fromSection.parentSection ? fromSection.section.name : false,
                    },
                    to: {
                        top: this.topSections.find(item => item.id == this.activeTopSection).name,
                        sect: toSection.parentSection ? toSection.parentSection.name : toSection.section.name,
                        sub: toSection.parentSection ? toSection.section.name : false,
                    },
                };
                this.$store.dispatch('popups/open', {name: this.popups.moveRule.name});
            } else {
                if (this.popups.notify.show && this.tumblers.notify.value && this.form.notifyTitle.value.length === 0) {
                    if (this.form.notifyTitle.error) {
                        this.form.notifyTitle.error = false;
                        setTimeout(() => {
                            this.form.notifyTitle.error = true;
                        }, 10);
                    } else {
                        this.form.notifyTitle.error = true;
                    }
                    error = true;
                }

                if (this.popups.notify.show && this.tumblers.notify.value && this.form.notifyText.value.length === 0) {
                    if (this.form.notifyText.error) {
                        this.form.notifyText.error = false;
                        setTimeout(() => {
                            this.form.notifyText.error = true;
                        }, 10);
                    } else {
                        this.form.notifyText.error = true;
                    }
                    error = true;
                }

                if (this.activeSection) {
                    this.$store.commit('rules/setSelectedSection', true);
                } else {
                    error = true;
                    this.$store.commit('rules/setSelectedSection', false);
                }

                if (!error) {
                    this.form.btnType = 'load';
                    this.form.sendMsg.btnType = 'load';
                    this.$emit('load', 'load');

                    let params = {
                        id: this.item.id ? this.item.id : this.form.itemId.value,
                    };

                    let formData = new FormData();
                    formData.append('name', this.form.title.value);
                    formData.append('text', this.form.text.value);
                    formData.append('section', this.activeSection);
                    formData.append('notifyInvolved', this.tumblers.notify.value && this.popups.notify.show);
                    formData.append('notifyInvolvedNew', this.isNotifyNew);
                    formData.append('finally', this.tumblers.finally.value);
                    formData.append('type', 'saveRule');
                    formData.append('notifyTitle', this.form.notifyTitle.value);
                    formData.append('notifyText', this.form.notifyText.value);
                    formData.append('notifySms', this.tumblers.notifySms.value);
                    formData.append('ruleType', this.form.filterType.value);

                    params.formData = formData;
                    params.activeSection = this.activeSection;

                    this.$store.dispatch('rules/setRule', params).then((item) => {
                        this.form.btnType = 'ok';
                        this.$emit('load', 'ok');
                        this.newCreatedId = item.id;
                        this.isSave = true;
                        setTimeout(() => {
                            this.form.btnType = 'normal';
                            this.form.sendMsg.btnType = 'normal';
                            this.$emit('load', 'normal');
                            if (!this.tumblers.notify.value || (this.tumblers.notify.value && this.popups.notify.show)) {
                                this.$store.commit('rules/tumblerOff', 'notifySms');
                                this.$store.commit('popups/close', {name: this.popups.notify.name});
                                this.$store.commit('popups/close', {name: this.popups.addRule.name});
                                this.$store.commit('popups/close', {name: this.popups.recoverRule.name});
                                window.location.hash = '';
                                if (this.$route.path !== '/sid' + item.sectionTop + '/sub' + item.section + '/rule' + item.id + '/') {
                                    if (item.sectionTop != item.section) {
                                        this.$router.push('/sid' + item.sectionTop + '/sub' + item.section + '/rule' + item.id + '/');
                                    } else {
                                        if(this.$route.params.subid ){
                                            this.$router.push('/sid' + this.$route.params.id + '/sub' + this.$route.params.subid + '/rule' + item.id + '/');
                                        } else {
                                            if(this.$route.params.id){
                                                this.$router.push('/sid'+this.$route.params.id+'/sub'+item.section+'/rule' + item.id +'/');
                                            } else {
                                                this.$router.push('/sid'+this.activeTopSection+'/sub'+item.section+'/rule' + item.id +'/');
                                            }
                                        }

                                    }
                                } else {
                                    this.$router.push('/sid'+this.$route.params.id+'/sub'+item.section+'/');
                                }
                            } else {
                                let sectionId = this.$router.history.current.params.id;
                                if (sectionId) {
                                    this.isNotifyNew = typeof (this.item.id) === 'undefined';
                                    this.$store.dispatch('rules/getNotifyData', {
                                        section: sectionId,
                                        item: item.id,
                                        isNew: typeof (this.item.id) === 'undefined'
                                    }).then((data) => {
                                        this.form.itemId.value = item.id;
                                        this.form.notifyTitle.value = data.template.THEME;
                                        this.form.notifyText.value = data.template.TEXT;
                                    });
                                }
                                this.$store.dispatch('popups/open', {name: this.popups.notify.name});
                            }
                            this.$store.commit('rules/setUseShortcut', false);
                            //На всякий случай очистим данные для редактирования раздела
                            this.$store.commit('rules/setEditSection', []);
                        }, 200);
                    });
                }
            }

        },
        getSectionName(id) {
            let result;
            if (this.sections.length) {
                this.sections.forEach(function (item, i, arr) {
                    if (item.id == id) {
                        result = item.name;
                        return false;
                    }
                });
            }

            return result;
        },
        showImage(e) {
            this.$store.commit('rules/setItemFiles', {items: []});
            this.updateImages(this.form.text.value);
            let id = e.detail;
            for (let i in this.files) {
                if (this.files[i].id == id) {
                    this.showViewer(i);
                    break;
                }
            }
        },
    }
}
</script>

<style>
.editor .image {
    user-select: text;
    line-height: 62px !important;
    font-size: 54px !important;
    text-align: left;
    padding: 0;
}

.editor p.is-editor-empty:first-child::before {
    font-size: 14px;
    line-height: 17px;
    opacity: 0.5;
    content: attr(data-empty-text);
    float: left;
    pointer-events: none;
    height: 0;
}

.editor .image, .editor .youtube, .editor .preloader {
    height: 65px;
    width: 87px;
    margin-right: 8px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid rgba(84, 84, 84, .2);
    display: inline-block;
    cursor: pointer;
    transition: all .15s ease;
}

.editor .other-file {
    border: 1px solid #545454;
    color: #FFC700;
    font-weight: bold;
    font-size: 10px;
    padding-top: 14px;
    width: 32px;
    height: 48px;
    border-radius: 2px;
    text-align: center;
    display: inline-block;
}

.editor .image:hover {
    border-color: #2f80ed
}

.editor p {
    margin-bottom: 12px
}

.editor p:last-child {
    margin-bottom: 0;
}

.editor p + p {
    margin-top: 12px;
}
</style>
